export enum ModalsKey {
  EditFollowBet = 'edit-follow-bet',
  FollowBet = 'follow-bet',
  GameReport = 'game-report',
  ProfileUrl = 'profile-url',
  CancelRegister = 'cancel_register',
  UserProfile = 'user-profile',
  LiveChatRules = 'live-chat-rules',
  Terms = 'terms-refer',
  Login = 'login',
  Register = 'register',
  FollowBetTutorial = 'follow-tutorial',
  TrendTutorialModal = 'trenball-trend-tutorial',
  LuckySpin = 'lucky-spin',
  VipLevel = 'vip-level',
  ClaimReward = 'claim-reward',
  ClaimBonus = 'claim-bonus',
  LastRounds = 'last-rounds',
  LastBets = 'last-bets',
  Story = 'story',
  CreateReferralVoucher = 'create-referral-voucher',
  DeleteReferralVoucher = 'delete-referral-voucher',
  EditReferralVoucher = 'edit-referral-voucher',
  WithdrawReferralComissions = 'referral-withdraw-comissions',
  UnavailableBalance = 'unavailable-balance',
  Wallet = 'wallet',
  RecoverPassword = 'recover-password',
  RecoverPasswordReset = 'recover-password-reset',
  CoinConversion = 'coin-conversion',
  AuthComponentModal = 'auth-component-modal',
  Language = 'language',
  VerifyKyc = 'verify-kyc',
  MissionUncrossableDifficultyInfo = 'mission-uncrossable-difficulty-info',
  BonusDetails = 'bonus-details',
  ProfileDetails = 'profile-details',
  RollCompetition = 'roll-competition',
  Notifications = 'notifications',
  Share = 'share',
  TestUser = 'test-user',
  TransactionReport = 'transaction-report',
  UserEmail = 'user-email',
  Deposit = 'deposit',
  Withdraw = 'withdraw',
  SupportModal = 'support-modal',
  UserPhoneNumber = 'user-phone-number',
  RolloverRequired = 'rollover-required',

  Redirect = 'redirect-country',
  Restriction = 'restriction',
  SelfExclusion = 'self-exclusion',
  EndSession = 'end-session',
  UserRestrictionsDetails = 'user-restrictions-details',
  //Bruno
  SetNewPassword = 'new-password',
  SetTwoFactor = 'two-factor',
  SetTwoFactorEmail = '2fa-email',
  setPasskey = 'set-passkey',
  //restrictiosn
  limitLoss = 'limit-loss',
  gameSession = 'game-session',
  wagerLimit = 'wager-limit',
  withdrawLimit = 're-withdraw-limit',
  depositLimit = 're-deposit-limit',
}
